<app-auth-form
	[isRegister]="3"
	[loading]="loading"
	[showSuccessState]="success"
	(formSubmit)="onSubmit($event)"
></app-auth-form>
